import React from 'react';
import PropTypes from 'prop-types';
import EditOnHoverTextbox from '../../common/components/edit-on-hover-textbox.jsx';
import { Image } from "../../common/components/image";
import Radio from "../../common/components/forms/radio";
import Checkbox from "../../common/components/forms/checkbox";
import {formatDurationAsTime} from "../../common/components/forms/format";

export const AlbumThumbnail = props => {
	let photosString = '';
	let videosString = '';

	if(props.stats) {
		if(props.stats.numPhotos) {
			photosString = `${props.stats.numPhotos} Photos`;
		}
		if(props.stats.numClips) {
			videosString = `${props.stats.numClips} Video`;
			if(props.stats.numClips > 1){
				videosString += "s"
			}
			if(props.stats.videoDuration > 0){
				videosString += " (" + formatDurationAsTime(props.stats.videoDuration,true,false) + ")";
			}
		}
	}
	
	return (
		<div className="album-thumbnail-with-title" aria-label="Thumbnail!">
			<div className="album-shadow">
				<div className="album-shadow-top"/>
				<div className="album-shadow-bottom"/>
			</div>
			<div className={`album-thumbnail`} onClick={props.albumClicked} data-album-id={props.id}>
				{getImageForDisplayMode(props.selectMode, props.showMenu, props.selected, props.toggleSelected, props.id, props.hideMenu || false,props.snapfishMode)}
				<div className="album-thumbnail-images">
					<div className="album-thumbnail-images-large">
						<Image className="album-image" source={props.thumbnails && props.thumbnails.length > 0 ? props.thumbnails[0] : require("../../common/images/icon-missing-asset-grey.svg")} alt="" />
					</div>
				</div>
			</div>
			<div className="thumb-description" onClick={(event)=> {event.preventDefault();event.stopPropagation()}}>
				<EditOnHoverTextbox className="album-thumbnail-title" text={props.title} onChange={props.onTitleChange} />
				{props.stats.numPhotos > 0 && <span className="album-item-count-description">{photosString}</span>}
				{props.stats.numClips > 0 && <span className="album-item-count-description">{videosString}</span>}
				{!props.hideMenu && !props.selectMode && <div className="album-thumbnail-menu-button-horizontal" onClick={props.showMenu} data-album-id={props.id} alt="menu"/>}
			</div>
		</div>
	);
};

AlbumThumbnail.propTypes = {
	albumClicked: PropTypes.func,
	linkPath: PropTypes.string,
	title: PropTypes.string,
	id: PropTypes.number,
	thumbnails: PropTypes.arrayOf(PropTypes.string),
	showMenu: PropTypes.func,
	selected: PropTypes.bool,
	selectMode: PropTypes.bool.isRequired,
	snapfishMode: PropTypes.bool,
	stats: PropTypes.object,
	onTitleChange: PropTypes.func.isRequired
};

const getImageForDisplayMode = (selectMode, clickHandler, selected, toggleSelected, id, hideMenu,snapfishMode = false) => {
	// if(snapfishMode || selectMode) {
	// 	return <span/>;
	// }

	if (selectMode) {
		return (
			<div className="album-thumbnail-check" data-album-id={id}>
				<Checkbox checked={selected} onChange={toggleSelected} noWrap={true}/>
			</div>
		);
	}
	// } else if(!hideMenu) {
	// 	return (
	// 		<div className="album-thumbnail-menu-button" onClick={clickHandler} data-album-id={id}>
	// 			<div className="album-thumbnail-menu-image"  data-album-id={id}/>
	// 		</div>
	// 	);
	// }
};

const createSmallThumbnails = (thumbnails, id) => {
	let returnValues = [];
	for (let i = 1; i < 4; i++) {
		if (thumbnails && thumbnails[i])
			returnValues.push(
				<Image className={'small-album-image'} source={thumbnails ? thumbnails[i] : ''} key={`album.thumb.${id}.${i}`} alt="thumb11" />
			);
		else returnValues.push(<img className={'small-album-image'} key={`album.thumb.${id}.${i}`} alt="" src={require("../../common/images/icon-missing-asset-grey.svg")} />);
	}
	return returnValues;
};



// WEBPACK FOOTER //
// ./src/album-view/components/album-thumbnail.jsx